import { Component, OnInit, ViewChild, ElementRef, Inject, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { Participante } from '@app/models/participante.model';
import { EstadoCivil } from '@app/models/util/estado-civil';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ParticipanteService } from '@app/services/participante.service';
import { ConsultasService } from '@app/services/consultas.service';
import { CDSMask } from '@app/utils/cds-mask';
import { ValidaDocumento } from '@app/utils/valida-documento';
import  * as paises from '../participante-form/paises.json';
import { ParticipanteOcorrencias } from '@app/models/participante-ocorrencias.model';
@Component({
  selector: 'app-participante-form',
  templateUrl: './participante-form.component.html',
})
export class ParticipantesFormComponent implements OnInit {
  aguardandoSolicitacao: boolean = false;
  participante: Participante;
  cdsMask: CDSMask = new CDSMask();
  listaCidade: IdDescricao[] = [];
  listaEstadoCivil: EstadoCivil[];
  listaErros: string[];

  imgUrl: any;
  foto: File;
  titulo: string;
  gerarProcesso = 0;
  RGDataExpedicao = '';
  DataNascimento = '';
  codePaises: string;
  nomePaises : string

  validaDocumento: ValidaDocumento = new ValidaDocumento();
  paises: any = (paises as any).default;
  @ViewChild('verificaDocumentoModal', { static: true }) verificaDocumentoModal: TemplateRef<any>;
  listaCadastrosEncontrados: ParticipanteOcorrencias[] = [];
  bsModalRef: BsModalRef;
  bloqueiaEdicaoDocumento: boolean = true;

  // Essa variável tem intenção de ser uma flag para permitir o cadastro
  cadastroLiberado: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private participanteService: ParticipanteService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService,
    private _modalService: BsModalService
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
    this.participante = new Participante();
    this.imgUrl = 'assets/img/usuario-sem-img.png';
  }

  ngOnInit() {
    this.listaEstadoCivil = this.participanteService.obterListaEstadoCivil();
    this.consultasService.consultar('CIDADE').toPromise().then(data => this.listaCidade = data);

    this.route.params.subscribe(async params => {
      let id = params['id'];
      this.participante.Id = id;
      if (!id) {
        this.titulo = 'Novo Participante';
        this.inicializaNovoCadastro();
        this.participante.PaisCelular = "Brasil";
      }
      if (id) {
        this.titulo = 'Editar Participante';
        this.inicializaEdicaoCadastro(id);
      }
    });
  }

  pessoaJuridica(): boolean {
    return this.participante.TipoPessoa === 'J';
  }

  sanitizaNomeFantasia(event: any): void {
    const input = event.target as HTMLInputElement;
    input.value = this.removeEspacoExtra(input.value);
  }

  removeEspacoExtra(value: string): string {
    return value.replace(/\s{2,}/g, ' ');
  }

  validaDados() {
    // FIXME ==> Sanitizar mais dados?
    this.participante.Telefone ??= '';
    this.participante.Celular ??= '';
    this.participante.Email ??= '';

    const celularSemespaco = this.participante.Celular.trim()
    this.participante.Celular  = celularSemespaco

    this.participante.DataNascimento = new Date(this.DataNascimento);
    this.participante.RGDataExpedicao = new Date(this.RGDataExpedicao);
    // <==
    if (!this.validaDocumento.validaCPF_CNPJ(this.participante.CNPJ_CPF)) {
      this.toastr.error('Número de CPF/CNPJ Inválido');
      return false;
    }

    if(!this.participante.Telefone && !this.participante.Celular) {
      this.toastr.error('Pelo menos um dos campos Telefone ou Celular deve estar preenchido!');
      return false;
    }

    if (this.participante.Telefone && !this.validaDocumento.validaTelefone(this.participante.Telefone)) {
      this.toastr.error('Número de Telefone Inválido');
      return false;
    }

    if (this.participante.Celular && !this.validaDocumento.validaCelular(this.participante.Celular)) {
      this.toastr.error('Número de Celular Inválido');
      return false;
    }

    if (this.participante.Email != "" && !this.validaDocumento.validaEmail(this.participante.Email)) {
      this.toastr.error('E-mail Inválido');
      return false;
    }

    return true;
  }

  onSubmit() {
    let resultadoValidacao = this.validaDados() && this.cadastroLiberado;

    if (resultadoValidacao) {
      this.aguardandoSolicitacao = true;
      if (this.participante.Id === 0) {
        this.novoCadastro();
      } else {
        this.edicaoCadastro()
      }
    }

    if (!this.cadastroLiberado) {
      this.toastr.warning('Cadastro bloqueado, CPF já cadastrado!');
    }
  }

  private novoCadastro(): void {
    this.participanteService.gravar(this.participante)
      .toPromise().then(
        (data: any) => {
          if (this.foto) {
            const formData: FormData = new FormData();
            formData.append('file', this.foto, this.foto.name);
            this.participanteService.alterarFoto(data.Id, formData).toPromise().then();
          }

          this.redirecionaParaNovoProcesso(data.Id, this.participante.NomeFantasia);
        },
        (data: any) => {
          if (data.error) {
            this.listaErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        }
      );
  }

  private edicaoCadastro(): void {
    this.participanteService.gravar(this.participante)
      .toPromise().then(
        () => {
          if (this.foto) {
            const formData: FormData = new FormData();
            formData.append('file', this.foto, this.foto.name);
            this.participanteService.alterarFoto(this.participante.Id, formData).toPromise().then();
          }
          this.redirecionaParaNovoProcesso(this.participante.Id.toString(), this.participante.NomeFantasia);
        },
        (data: any) => {
          if (data.error) {
            this.listaErros = data.error.errors;
          }
          this.aguardandoSolicitacao = false;
        }
      );
  }

  private redirecionaParaNovoProcesso(id: string, nomeFantasia: string) {
    if (this.gerarProcesso === 0) {
      this.router.navigate(['./cadastros/participante']);
    } else if (this.gerarProcesso === 1) {
      this.router.navigate(['./processos/novo-processo-administrativo/' + id + '/' + nomeFantasia]);
    } else {
      this.router.navigate(['./processos/novo-processo-judicial/' + id + '/' + nomeFantasia]);
    }
  }

  readUrl(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.foto = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (readEvent: ProgressEvent) => {
        this.imgUrl = (<FileReader>readEvent.target).result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  buscaDocumento(tipo: 'modal' | 'campo'): void {
    let documento = this.participante.CNPJ_CPF;

    let condicaoSemCPF = (documento === '111.111.111-11');
    let condicaoTamanhoString = (documento.length === 14 || documento.length === 18);
    let numeroDeDocumentoValido = this.validaDocumento.validaCPF_CNPJ(documento);
    let condicoesParaBusca = (condicaoTamanhoString && numeroDeDocumentoValido);

    if (condicaoSemCPF) {
      this.fecharModalDocumento();
      return; //return necessário para controlar o fluxo sem aninhar mais um if;
    }

    if (condicoesParaBusca) {
      if (tipo === 'modal') {
        this.buscaDocumentoModal();
      }
      if (tipo === 'campo') {
        this.buscaDocumentoModificacaoCampo();
      }
    }else{
      this.toastr.error('CPF inválido.');

    }

  }

  private buscaDocumentoModal(): void {
    this.participanteService.verificarDocumentoCadastrado(this.participante.CNPJ_CPF).toPromise()
      .then(
        (resultado: ParticipanteOcorrencias[]) => {
          if (resultado.length === 1) {
            this.toastr.info('CPF encontrado.');
            this.router.navigate(
              ['cadastros', 'participante', 'editar', resultado[0].Id]
            ).then(
              () => this.fecharModalDocumento()
            );
          }

          if (resultado.length >= 2) {
            this.toastr.info(`Foram encontrados ${resultado.length} cadastros com esse CPF.`);
            this.listaCadastrosEncontrados = resultado;

            this.cadastroLiberado = false;
          }

          if (resultado.length === 0) {
            this.fecharModalDocumento();
            this.cadastroLiberado = true;
          }
        },
        error => console.error('Ocorreu algum erro, não foi possível verificar nos cadastros')
      );
  }

  private buscaDocumentoModificacaoCampo(): void {
    this.participanteService.verificarDocumentoCadastrado(this.participante.CNPJ_CPF).toPromise()
      .then(
        (resultado: ParticipanteOcorrencias[]) => {
          if (resultado.length === 1) {
            this.cadastroLiberado = false;
            this.redirecionarParaCadastro(resultado[0].Id);
          }

          if (resultado.length >= 2) {
            // TODO aqui está liberando para salvar enquanto houver registros duplicados no sistema ---//
            this.cadastroLiberado = true;
            // ----------------------------------------------------------------------------------------//

            this.toastr.error(`Foram encontrados ${resultado.length} cadastros com esse CPF`);
            this.listaCadastrosEncontrados = resultado;
          }

          if (resultado.length === 0) {
            this.cadastroLiberado = true;
          }
        },
        error => console.warn('Ocorreu algum erro, não foi possível verificar nos cadastros')
      );
  }

  private redirecionarParaCadastro(id: number) {
    if (this.participante.Id.toString() !== id.toString()) {
      this.bsModalRef = this._modalService.show(ModalConfirmarComponent);
      this.bsModalRef.content.mensagem = 'Cadastro encontrado, deseja redirecionar?';
      this.bsModalRef.content.confirmar = () =>
        this.router.navigate(
          ['cadastros', 'participante', 'editar', id]
        );
    } else {
      this.cadastroLiberado = true;
    }
  }

  /**
   * Caso ao gravar encontre 1 CPF que possui o mesmo id da rota, impedir novo cadastro
   * Caso ao gravar encontre mais de 1 CPF permitir salvar/gravar
   *
   */

  abrirModalDocumento(): void {
    this.bsModalRef = this._modalService.show(
      this.verificaDocumentoModal,
      {
        keyboard: false,
        ignoreBackdropClick: true
      }
    );
  }

  fecharModalDocumento(): void {
    this.bsModalRef.hide();
  }

  private inicializaNovoCadastro(): void {
    this.participante.Id = 0;
    this.participante.TipoPessoa = 'F';
    this.participante.Sexo = 'M';
    this.participante.EstadoCivil = 'SOLTEIRO';
    this.participante.Cliente = true;
    this.participante.Ativo = true;

    this.abrirModalDocumento();
  }

  private async inicializaEdicaoCadastro(id: any): Promise<void> {
    await this.participanteService.obterPorId(id).toPromise()
      .then(data => {
        if(data.PaisCelular == null) data.PaisCelular = "Brasil";
        (document.getElementById('selectPaises') as HTMLSelectElement).value = data.PaisCelular;
        this.participante = data;
        this.RGDataExpedicao = data.RGDataExpedicao ? data.RGDataExpedicao.split('T')[0] : null;
        // this.RGDataExpedicao = this.participante.RGDataExpedicao.toISOString().split('T')[0];
        this.DataNascimento = data.DataNascimento.split('T')[0];
        if (this.participante.Foto) {
          this.imgUrl = this.participante.Foto;
        } else {
          this.imgUrl = 'assets/img/usuario-sem-img.png';
        }
      },
        (error) => this.router.navigate(['./cadastros/participante'])
      );
      this.dddPaises(this.participante.PaisCelular)
  }


  dddPaises(nome:string){
    var paisIndex = this.paises.findIndex((paises:{name:any})=> paises.name == nome);
    this.codePaises = this.paises[paisIndex].code;
    //this.nomePaises = this.paises[paisIndex].name;
    this.participante.PaisCelular = nome;
    this.cdsMask.ddi(this.codePaises);
  }
}
